/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 * Input text that matchs a pattern
 * Component will notify the value only if its valid
 */
import React, { Component } from 'react';
import { TextField } from 'material-ui';

class PatternInput extends Component {

    constructor(props) {
        super(props);
        this.state = { error: '' };
        this.regex = new RegExp(props.pattern);
    }

    render() {
        const { error } = this.state;
        const { hintText, errorText, notify, searchTexts} = this.props;
        return (
            <TextField
                fullWidth
                hintText={hintText}
                errorText={error}
                value={searchTexts}
                onChange={(event, value) => {
                    const isValid = this.regex.test(value);
                    if (!isValid) {
                        this.setState({ error: errorText });
                        notify(value);
                    } else {
                        this.setState({ error: '' });
                        notify(value);
                    }
                }}
            />
        );
    }
}

export default PatternInput;



// WEBPACK FOOTER //
// ./components/filters/patternInput.js